<div
  *ngIf="settings.length"
  class="sp-width__full sp-overflow__x-scroll sp-position__relative sp-card sp-table__sticky-header__no-summary">
  <table
    mat-table
    [dataSource]="settings"
    class="sp-width__full">
    <ng-container matColumnDef="setting">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'SETTINGS.SETTING_COLUMN_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let setting">
        <span class="sp-color__primary sp-text__ellipsized sp-text__bold">
          {{ setting.label | translate }}
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'SETTINGS.ACTIONS_COLUMN_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let setting">
        <div class="sp-row__align">
          <button
            mat-icon-button
            class="sp-icon__button sp-icon__button-dark sp-margin__left"
            [matTooltip]="'GENERAL.SEE_DETAILS_CTA' | translate"
            (click)="onProductCategoryClick(setting.path)">
            <mat-icon class="material-symbols-outlined"> visibility </mat-icon>
          </button>
        </div>
      </td>
    </ng-container>

    <tr
      mat-header-row
      *matHeaderRowDef="displayed_columns; sticky: true"></tr>
    <tr
      mat-row
      class="sp-cursor__pointer"
      *matRowDef="let row; columns: displayed_columns"></tr>
  </table>
</div>
